import { render, staticRenderFns } from "./AgendaViewComponent.vue?vue&type=template&id=733d13ba"
import script from "./AgendaViewComponent.vue?vue&type=script&lang=js"
export * from "./AgendaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports